export default {
  gewerbe: {
    hero: {
      eyebrow: 'عملاء الأعمال',
      title: 'مراقبة بالفيديو احترافية لمتطلبات الأعمال',
      lead: 'من فرع التجزئة إلى قاعة الإنتاج – نخطط ونركّب وندير أنظمة كاميرات تخدم نشاطك. مع مراعاة الخصوصية وقابلة للتوسع وموثوقة.',
    },
    types: {
      title: 'حلول لنشاطك التجاري',
      lead: 'لكل قطاع متطلباته الخاصة. نعرف التحديات النموذجية ونخطط وفقًا لذلك.',
      items: {
        '0': { title: 'التجزئة والمتاجر', desc: 'المدخل وسطح البيع ومنطقة الدفع والمستودع – مراقبة بسرية وفعالية. حماية من السرقة والتخريب.', tags: { '0': 'داخلي', '1': 'حماية من السرقة', '2': 'منطقة الدفع' } },
        '1': { title: 'المكاتب والعيادات', desc: 'الاستقبال والممرات والمناطق الحساسة ومواقف السيارات – مع حقوق وصول ومناطق خاصة.', tags: { '0': 'داخلي', '1': 'الاستقبال', '2': 'الخصوصية' } },
        '2': { title: 'المستودعات واللوجستيات', desc: 'مراقبة مساحات واسعة بزاوية عريضة وPTZ. رؤية مناطق التسليم والرفوف والخارج نهارًا وليلًا.', tags: { '0': 'داخلي', '1': 'خارجي', '2': 'رؤية ليلية' } },
        '3': { title: 'المطاعم', desc: 'المدخل والمنضدة ومدخل المطبخ والخارج – كاميرات متينة للبيئات الرطبة والحارة.', tags: { '0': 'داخلي', '1': 'خارجي', '2': 'متينة' } },
        '4': { title: 'الورش والصناعة', desc: 'البيئات الأصعب تتطلب كاميرات متينة بشكل خاص. ورش ومساحات خارجية ومناطق تحميل محمية.', tags: { '0': 'داخلي', '1': 'متينة', '2': 'رؤية ليلية' } },
        '5': { title: 'مواقع متعددة', desc: 'وصول مركزي إلى جميع الكاميرات عبر تطبيق واحد. إدارة مستخدمين بحقوق متمايزة.', tags: { '0': 'مواقع متعددة', '1': 'مركزي', '2': 'تطبيق' } },
      },
    },
    features: {
      title: 'وظائف للاستخدام التجاري',
      lead: 'التركيبات التجارية تتطلب أكثر من الكاميرات. نُعدّ الحقوق وجداول التسجيل والإشعارات باحترافية.',
      items: {
        '0': { title: 'إدارة المستخدمين', desc: 'حقوق وصول مختلفة للموظفين ومديري الفروع والإدارة. من يمكنه رؤية أي كاميرا؟' },
        '1': { title: 'التسجيل والأرشفة', desc: 'مسجّل محلي بتخزين مكرر. مدة الحفظ حسب المتطلبات التشغيلية والقانونية.' },
        '2': { title: 'إشعارات الأحداث', desc: 'رسائل دفع عند الحركة أو عبور الخط أو أحداث محددة، حسب النظام.' },
        '3': { title: 'قابلية التوسعة', desc: 'هل ينمو نشاطك؟ يمكن عادةً توسعة الأنظمة الحالية بكاميرات ومواقع إضافية.' },
      },
    },
    legal: {
      eyebrow: 'حماية البيانات والقانون',
      title: 'مراقبة أعمال متوافقة قانونيًا',
      lead: 'تنطبق قواعد إضافية على المراقبة التجارية – خاصة بخصوص الموظفين والعملاء والمناطق العامة. ندعمك في التنفيذ التقني لـ:',
      list: {
        '0': 'الشفافية واللافتات عند المداخل',
        '1': 'إخفاء غرف تبديل الملابس والاستراحة',
        '2': 'التنفيذ التقني لحقوق الوصول وإدارة المستخدمين',
        '3': 'تخزين محلي بفترة حفظ محددة',
        '4': 'توثيق الضرورة التشغيلية',
      },
      note: 'ملاحظة: تعتمد شرعية مراقبة الأعمال على الحالة الفردية. ننصحك تقنيًا دون أن نغني عن الاستشارة القانونية.',
    },
    cta: {
      title: 'نشاطك يستحق أمانًا احترافيًا',
      lead: 'نحلل عملياتك ونخطط نظامًا يحمي دون إزعاج. دون التزام وبشفافية.',
      primary: 'احجز موعد استشارة',
      secondary: 'اكتشف SSG Care',
    },
  },
};